<template>
  <div
    class="magnify"
    id="magnify"
    v-show="dateInfo.show">
    <div
      class="mask"
      :style="{ width: '100%' }"></div>
    <div
      class="content"
      @click="(e) => {e.stopPropagation();}"
    >
      <i
        class="el-icon-close pointer"
        @click="close"> </i>
      <div class="tr title">
        <div>
          <div
            class="th"
            v-for="(v, i) in dateInfo.date.weekTitle"
            :key="i">
            {{ v }}
          </div>
        </div>
      </div>
      <div
        class="calendar_content"
        v-loading="Eventloading"
        element-loading-background="rgba(0, 0, 0, .6)"
      >
        <div class="tbody">
          <div
            class="tr"
            v-for="(v, min) in 30"
            :key="min">
            <div
              class="td pr pointer"
              v-for="(itm, idx) in dateInfo.date.weekTitle"
              :style="{ width: `${idx != 0 ? 94.5 / (dateInfo.date.weekTitle.length - 1) + '%' : '5.5%' }`}"
              :key="idx"
            >
              <!-- 数据太多会影响加载速度,没什么用所以去掉 -->
              <!-- :class='getClass(dateInfo.date.date[idx - 1], getDateTime(dateInfo.date.start, min), idx, min)' -->
              <div class="event_title">
                {{ transformTime(dateInfo.date.start, idx, min) }}
              </div>
              <div
                class="second pr"
                v-for="(item, second) in 60"
                :key="second"
                :data-datetime="`${dateInfo.date.date[idx - 1]} ${getDateTime(
                  dateInfo.date.start,
                  min,
                  second
                )}`"
                :data-date="dateInfo.date.date[idx - 1]"
                :data-time="getDateTime(dateInfo.date.start, min, second)"
                :date-second="second"
                @click="openBox($event, dateInfo.date.start, idx, min, second)"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 判断是否需要取整 -->
    <media-time-floor v-if="MediaTimeFloor.show" :MediaTimeFloor="MediaTimeFloor" @RoundSelectRes="RoundSelectRes"></media-time-floor>
    <!-- 创建框 -->
    <popup-box
      v-if="EventMotion.switch"
      :picthOnEvent="picthOnEvent"
      :EventMotion="EventMotion.motion"
      :fixedDevice="fixedDevice"
      :BoxPosition="createBox"
      @closeCreateBox="EventMotion.switch = false"
      @OperationSuccess="OperationSuccess"
    ></popup-box>
     <!-- 强制填充选项框 -->
    <force-fill-select v-if="forceFillMessage.show" :forceFillMessage='forceFillMessage' @forceFillSelect='forceFillSelect'></force-fill-select>
  </div>
</template>
<script>
import Outil from '@/assets/js/utils.js'
import Drag from '@/assets/js/common/drag'
import Bus from '@/assets/js/vueBus.js'
import { mapState } from 'vuex'
import RenderEvent from './common/renderEvent/index'
import toTips from '@/assets/js/toTipsObj'
import PopupBox from '@/components/common/PopupBox.vue'
import NotManyEdit from '@/assets/js/NotManyEdit.js'
import ForceFillSelect from '@/components/common/ForceFillSelect.vue'
import MediaTimeFloor from '@/components/file/MediaTimeFloor.vue'
import commonRequest from '@/assets/js/common/commonRequest.js'

export default {
  components: {
    PopupBox,
    ForceFillSelect,
    MediaTimeFloor
  },
  computed: {
    ...mapState({
      // 多选选中的文件夹
      PitchOnFileList: (state) => state.playout.PitchOnFileList,
      // 高级配置的某些参数
      AdvancedSetupConfig: (state) => state.playout.AdvancedSetupConfig
    })
  },
  props: {
    dateInfo: {
      type: Object,
      default: () => {}
    },
    events: Array,
    fixedDevice: Object,
    dynamicDevice: Object
  },
  data () {
    return {
      // 选中事件对象
      picthOnEvent: {},
      // 弹窗的动作,对于事件
      EventMotion: {
        switch: false,
        motion: 0
      },
      // 弹出框位置
      createBox: {},
      ele: null, // 拖拽对象
      boxElement: null, // 创建框实例
      form: {}, // 创建事件参数
      rendEvents: null,
      formatTemplateData: [],
      Eventloading: true, // 事件处理中
      // 强制填充选择框数据
      forceFillMessage: {
        show: false
      },
      // 间隙数据
      GapTime: {},
      // 是否取整
      MediaIsRound: false,
      // 增加提示是否取整
      MediaTimeFloor: {
        show: false,
        type: 'single' // 类型是多文件还是单文件
      }
    }
  },
  created () {},
  mounted () {
    Bus.$on('leftListUpdate', this.registerDrag)
    Bus.$on('popupCreateBox', (data) => {
      this.openEventFormBox(data.e, data.event, 0)
    })
    setTimeout(() => {
      this.renderEvent()
    }, 1)
    // 获取media是否取整
    commonRequest.getMediaIsRound().then((res) => {
      this.MediaIsRound = res
    })
  },
  watch: {
    events () {
      this.rendEvents = this.rendEvents && this.rendEvents.removeAll()

      this.renderEvent()
    },
    // 监听弹出框开关
    'EventMotion.switch' (item) {
      if (item) {
        // 禁止滚动条滚动
        $('.magnify .content .calendar_content').css('overflow-y', 'hidden')
      } else {
        // 开启滚动条滚动
        $('.magnify .content .calendar_content').css('overflow-y', 'scroll')
      }
    }
  },
  methods: {
    // 渲染事件
    renderEvent () {
      for (let i = 0; i < this.events.length; i++) {
        const v = this.events[i]
        const startTimeObj = Outil.getDateTime(new Date(v.startTime))
        let duration = v.endTime - v.startTime
        // date 事件的日期时间
        const date = `${startTimeObj.year}/${startTimeObj.month}/${startTimeObj.day}`
        const time = `${startTimeObj.hour}:${startTimeObj.min}:${startTimeObj.s}`
        let parentDom = document.querySelector(
          `div[data-datetime="${`${date} ${time}`}"]`
        )
        // 从中断开
        const breakMessage = {}
        // 获取事件开始时间对应的dom盒子 存在即在zoom时间范围内
        // 开始时间不在zoom时间范围中
        if (!parentDom) {
          for (let j = 0; j < this.dateInfo.date.date.length; j++) {
            const dateVal = this.dateInfo.date.date[j]
            // 当前时间的开始时间
            const timestamp = new Date(
              `${dateVal} ${this.dateInfo.date.start}`
            ).getTime()
            // 当前时间在事件的持续时间范围内
            if (timestamp >= v.startTime && timestamp <= v.endTime) {
              // 如果从中断开 存一下zoom开始时间
              breakMessage.break = true
              breakMessage.timestamp = timestamp
              // 当前事件在时间格子内占据时长
              duration = v.endTime - timestamp
              parentDom = document.querySelector(
                `div[data-datetime="${
                  `${dateVal} ${this.dateInfo.date.start}:00`
                }"]`
              )
              break
            }
          }
          if (!parentDom) continue
        }
        // .42是一秒格子的高度
        let height = `${(duration / 1000) * 0.42}`
        height = height > 750 ? '750px' : `${height}px`
        const styleVal = {
          height,
          backgroundColor: v.backgroundColor
        }

        const propsData = {
          styleVal,
          title: v.title,
          dateTime: time,
          dateEvent: v,
          fixedDevice: this.fixedDevice,
          dynamicDevice: this.dynamicDevice,
          events: this.events,
          breakMessage
        }
        this.rendEvents = new RenderEvent(parentDom, propsData)
      }
      // this.$forceUpdate()
      this.$nextTick(() => {
        this.dragAndDrop()
        this.Eventloading = false
      })
    },
    // 获取范围内的前一个最近事件
    getPreEvent (currentTime, scopeStart, scopeEnd) {
      let preEvent
      this.events.forEach((v) => {
        // 事件的结束时间是否在点击时间之前，并在方格时间范围内
        if (
          v.endTime < currentTime &&
          v.endTime >= scopeStart &&
          v.endTime <= scopeEnd
        ) {
          // scopeEvent.push(v)
          if (!preEvent) {
            preEvent = v
          } else {
            const differ = currentTime - v.endTime
            const preEventDiffer = currentTime - preEvent.endTime
            if (differ < preEventDiffer) {
              preEvent = v
            }
          }
        }
      })
      return preEvent
    },
    // 重新注册拖拽
    registerDrag () {
      setTimeout(() => {
        this.dragAndDrop()
      }, 100)
    },
    // 拖拽
    dragAndDrop () {
      this.ele = new Drag()
      this.ele.create({
        // 能够拖拽到的区域
        dropZones: document.querySelector('.magnify .content .tbody'),
        // 拖动的元素
        from: [
          document.querySelectorAll('.magnify .content .tbody .event_box'),
          document.querySelectorAll('.draggable_box .draggable_item')
        ],
        // 拖拽结束的时候触发
        dropEnd: (e) => {
          // e 落下的盒子
          // 判断是原来有的换位置还是重新拖拽过来创建的
          const programTemplate = this.ele.dragElement.dataset.programtemplate
          if (programTemplate) {
            // 拖拽dom所携带的参数
            const device = JSON.parse(this.ele.dragElement.dataset.device)
            this.DragProgramTemplate(e, device)
          } else if (this.ele.dragElement.dataset.event) {
            // this.editEvent(e)
          } else {
            // 拖拽dom所携带的参数
            const device = JSON.parse(this.ele.dragElement.dataset.device)
            this.dropDragEnd(e, device)
          }
        }
      })
    },
    // 拖拽program模板
    DragProgramTemplate (e, device) {
      const param = {
        eventTemplateId: device.id,
        receiverId: this.fixedDevice.peerId
      }
      const datasetDate = e.target.dataset.date
      // 秒盒子的毫秒数
      const curTime = new Date(`${datasetDate} ${e.target.dataset.time}`).getTime()
      const time = e.target.dataset.time.split(':')
      // 秒数置0的毫秒数
      const scopeStart = new Date(`${datasetDate} ${this.getDateTime(`${time[0]}:0`, time[1], 0)}`).getTime()
      param.startTime = scopeStart
      const scopeEnd = scopeStart + 60 * 1000
      const preEvent = this.getPreEvent(curTime, scopeStart, scopeEnd)
      if (preEvent) {
        param.startTime = preEvent.endTime
      }
      this.axios.post('/gatewayPlayoutUrl/tvu-playout/event/addEventByTemplateId', param)
        .then((res) => {
          if (res.status == 200) {
            if (res.data.errorCode == '0x0') {
              this.$message({
                type: 'success',
                message: this.$t('lang.success')
              })
              Bus.$emit('updateEventList')
            } else {
              const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
              this.$message.info(errorInfo)
            }
          }
        }).catch(() => {})
    },
    // 拖拽事件进行修改
    editEvent (e) {
      const event = JSON.parse(this.ele.dragElement.dataset.event).item
      const duration = new Date(event.endTime).getTime() - event.startTime
      event.startTime = new Date(
        `${e.target.dataset.date} ${e.target.dataset.time}`
      ).getTime()
      event.endTime = event.startTime + duration
      this.openEventFormBox(e, event, 1)
    },
    // 拖拽事件进行自动创建
    dropDragEnd (e, device) {
      device.duration = device.videoTimes * 1000 || device.duration
      this.form.bitrate = 5120
      this.form.color = device.setType == 'break' ? 'rgb(146, 72, 199)' : 'rgb(255, 192, 0)',
      this.form.delay = 2
      this.form.description = ''
      this.form.reporter = ''
      this.form.rpeerid = this.fixedDevice.peerId
      this.form.scheduleType = 'live'
      this.form.title = device.name
      this.form.tname = device.name
      this.form.tpeerid = device.peerId || device.sourceId
      this.form.ttype = device.type
      this.form.turl = device.url
      let duration = 60 * 1000
      if (['video', 'file', 'scte'].includes(device.type.toLowerCase())) {
        duration = device.duration
        this.form.duration = duration
        this.form.fileId = device.id
        this.form.sourceType = 0
        this.form.record = 0
      } else {
        this.form.sourceType = 1
      }
      const datasetDate = e.target.dataset.date
      // 秒盒子的毫秒数
      const curTime = new Date(
        `${datasetDate} ${e.target.dataset.time}`
      ).getTime()
      console.log(curTime, '秒盒子的毫秒数')
      const time = e.target.dataset.time.split(':')
      // 秒数置0的毫秒数
      const scopeStart = new Date(
        `${datasetDate} ${this.getDateTime(
          `${time[0]}:0`,
          time[1],
          0
        )}`
      ).getTime()
      console.log(scopeStart, 'fen盒子的毫秒数')
      this.form.startTime = scopeStart
      const scopeEnd = scopeStart + 60 * 1000
      const preEvent = this.getPreEvent(curTime, scopeStart, scopeEnd)
      if (preEvent) {
        this.form.startTime = preEvent.endTime
      }
      this.form.endTime = this.form.startTime + duration
      if (this.PitchOnFileList[device.id]) {
        if (!this.MediaIsRound) {
          // 判断多个文件时间是否有浮点数
          const IsRound = Object.keys(this.PitchOnFileList).some((key) => {
            const item = this.PitchOnFileList[key]
            const videoTimes = item.videoTimes ? Number(item.videoTimes) : 0
            // 判断是否是浮点数
            return parseInt(videoTimes) !== videoTimes
          })
          if (IsRound) {
            this.MediaTimeFloor.show = true
            this.MediaTimeFloor.type = 'batch'
            return
          }
        }
        this.batchAddEvent(this.form.startTime, true)
      } else {
        let videoTimes = duration / 1000
        this.form.videoTimes = videoTimes
        // 判断是否是浮点数
        if (parseInt(videoTimes) !== videoTimes) {
          // 判断是否需要取整
          if (this.MediaIsRound) {
            videoTimes = Math.floor(videoTimes)
          } else {
            this.MediaTimeFloor.show = true
            this.MediaTimeFloor.type = 'single'
            return
          }
        }
        duration = videoTimes * 1000
        this.form.duration = duration
        this.form.endTime = this.form.startTime + duration
        this.autoAddEvent()
      }
    },
    // 取整选择结果
    RoundSelectRes (value) {
      if (this.MediaTimeFloor.type == 'single') {
        let videoTimes = this.form.videoTimes
        if (value == 1) {
          videoTimes = Math.floor(videoTimes)
        }
        this.form.duration = videoTimes * 1000
        this.form.endTime = this.form.startTime + videoTimes * 1000
        this.autoAddEvent()
      } else if (this.MediaTimeFloor.type == 'batch') {
        const ListStartTime = this.form.startTime
        const IsRound = value == 1
        this.batchAddEvent(ListStartTime, IsRound)
      }
    },
    // 批量添加事件
    batchAddEvent (startTime, IsRound) {
      const EventList = []
      let ListStartTime = startTime
      Object.keys(this.PitchOnFileList).forEach(key => {
        const item = this.PitchOnFileList[key]
        let duration = item.videoTimes ? Number(item.videoTimes) : 0
        duration = IsRound ? Math.floor(duration) : duration
        const eventParam = {
          bitrate: 5120,
          color: item.setType == 'break' ? 'rgb(146, 72, 199)' : 'rgb(255, 192, 0)',
          delay: 2,
          rpeerid: this.fixedDevice.peerId,
          scheduleType: 'live',
          sourceType: 0,
          title: item.name,
          name: item.name,
          tpeerid: item.peerId || item.sourceId,
          ttype: item.type,
          turl: item.url,
          duration: duration * 1000
        }
        eventParam.startTime = ListStartTime
        eventParam.endTime = eventParam.startTime + eventParam.duration
        const eventSegments = {
          segmentId: 1,
          segmentOrder: 0,
          timingIn: eventParam.startTime,
          timingOut: eventParam.endTime
        }
        eventParam.eventSegments = [eventSegments]
        ListStartTime = eventParam.endTime
        EventList.push(eventParam)
      })
      this.axios({
        method: 'post',
        url: Outil.getUrl('/event/batchAdd'),
        data: {
          eventParams: EventList
        }
      }).then((res) => {
        if (res.status == 200 && res.data.errorCode == '0x0') {
          Bus.$emit('updateEventList')
          return
        }
        const errorInfo =
          this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
        this.$message.error(errorInfo)
      }).catch(() => {})
    },
    // 强制填充弹框确认
    forceFillSelect (type) {
      if (type == 1) {
        this.form.startTime = this.GapTime.startTime
        this.form.endTime = this.GapTime.endTime
      } else {
        this.form.startTime = this.GapTime.startTime
        this.form.moveAllEventMoreThanEndTime = 1
      }
      this.addEvent()
    },
    // 拖拽后自动创建
    async autoAddEvent () {
      if (!this.form.startTime || !this.form.endTime) {
        this.$message.error(this.$t('lang.durEmpty'))
        return
      }
      // 实时流填充间隙
      if (this.form.sourceType == 1) {
        const GapTime = await Outil.getEventGap(this.form.startTime)
        if (GapTime && GapTime.duration > 0) {
          if (GapTime.duration <= 1800000) {
            this.form.startTime = GapTime.startTime
            this.form.endTime = GapTime.endTime
          }
        }
        this.form.record = this.AdvancedSetupConfig.defaultSecondaryRecord ? 1 : 0
        this.form.replay = this.form.record
      } else if (this.form.sourceType == 0) {
        const GapTime = await Outil.getEventGap(this.form.startTime)
        this.GapTime = GapTime
        if (GapTime.forcePopulate) {
          if (GapTime.duration != -2) {
            if (GapTime && GapTime.duration > 0) {
              if (GapTime.duration < this.form.duration) {
                this.forceFillMessage.show = true
                return
              }
            }
          }
        }
      }
      this.addEvent()
    },
    addEvent () {
      if (this.form.title.length > 220) {
        this.$message.error(this.$t('lang.eventTitleLength'))
        return
      }
      const eventSegments = {
        segmentId: 1,
        segmentOrder: 0,
        timingIn: this.form.startTime,
        timingOut: this.form.endTime
      }
      this.form.eventSegments = [eventSegments]
      this.axios({
        method: 'post',
        url: Outil.getUrl('/event/add'),
        data: this.form
      }).then((res) => {
        if (res.status == 200) {
          if (res.data.errorCode == '0x0') {
            Bus.$emit('updateEventList')
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.error(errorInfo)
          }
        }
      }).catch(() => {})
    },
    confirmName () {},
    // 将事件绑定到元素上
    bindEvent (event) {
      return (event && JSON.stringify(event)) || ''
    },
    // 关闭弹窗
    close () {
      try {
        this.boxElement && this.boxElement.close()
      } catch {}
      this.$emit('close')
      this.$emit('update:visible', false)
    },
    // 选中date time
    openBox (e, time, idx, min, second) {
      // 如果点击的是第一列
      if (idx == 0) {
        return
      }
      const { dataset } = e.currentTarget || e.target
      // 点击的是已创建的事件
      if (dataset.event) {
        const event = JSON.parse(dataset.event).item
        this.openEventFormBox(e, event, 0)
        return
      }
      if (!this.dynamicDevice) {
        this.$message.error(this.$t('lang.selectSource'))
        return
      }
      const timeVal = this.getDateTime(time, min)
      const dateVal = this.dateInfo.date.date[idx - 1]
      let startTime = new Date(`${dateVal} ${timeVal}`).getTime()
      const scopeStart = new Date(
        `${dateVal} ${this.getDateTime(time, min, 0)}`
      ).getTime()
      const scopeEnd = scopeStart + 60 * 1000
      const preEvent = this.getPreEvent(startTime, scopeStart, scopeEnd)
      const duration = 60 * 1000
      if (preEvent) {
        startTime = preEvent.endTime
      }
      const endTime = startTime + duration
      // 点击的时间小于当前时间
      if (startTime <= new Date().getTime()) {
        this.$message.error(this.$t('lang.startTimeLessThanCurTime'))
        return
      }

      this.openEventFormBox(e, {
        startTime,
        endTime,
        duration: 60 * 1000,
        tpeerid: '',
        record: false,
        //   新加子事件scte属性
        eventSegments: [],
        timeLock: 0,
        pgmEndScte: 0,
        pgmStartScte: 0
      })
    },
    // 打开创建编辑框
    openEventFormBox (e, event, type) {
      this.EventMotion.switch = false
      if (
        ['video', 'file', 'scte'].includes(
          event.ttype && event.ttype.toLowerCase()
        )
      ) {
        event.duration = event.endTime - event.startTime
      }
      this.picthOnEvent = event
      this.SetFramePosition(e)
      NotManyEdit.checkUserEdit({ type: 0, logicId: this.picthOnEvent.id }).then((res) => {
        if (res) {
          this.$nextTick(() => {
            this.EventMotion.motion = type == undefined ? 2 : type
            this.EventMotion.switch = true
          })
        }
      })
    },
    // event事件编辑创建删除完成
    OperationSuccess () {
      this.EventMotion.switch = false
      Bus.$emit('updateEventList')
    },
    // 计算弹出框位置
    SetFramePosition (jsEvent) {
      const ClickEvent = jsEvent || window.event
      const calendarLeft = document.getElementsByClassName('calendarLeft')[0].clientWidth
      const calendarRight = document.getElementById('magnify')
      const calendarRightTop = calendarRight.getBoundingClientRect().top
      const FramePosition = {
        top: ClickEvent.clientY - calendarRightTop,
        left: ClickEvent.clientX - calendarLeft,
        bottom: calendarRight.clientHeight - ClickEvent.clientY + calendarRightTop,
        right: calendarRight.clientWidth - ClickEvent.clientX + calendarLeft,
        ArrowsLeft: 60
      }
      if (FramePosition.bottom >= 430 && FramePosition.right >= 700) {
        this.createBox.top = FramePosition.top
        this.createBox.left = FramePosition.left - 70
        this.createBox.upward = true
        this.createBox.aleft = true
      } else if (FramePosition.bottom < 430 && FramePosition.right >= 700) {
        this.createBox.top = FramePosition.top
        this.createBox.left = FramePosition.left - 70
        this.createBox.upward = false
        this.createBox.aleft = true
      } else if (FramePosition.bottom >= 430 && FramePosition.right < 700) {
        this.createBox.top = FramePosition.top
        this.createBox.left = FramePosition.left + 70
        this.createBox.upward = true
        this.createBox.aleft = false
      } else {
        this.createBox.top = FramePosition.top
        this.createBox.left = FramePosition.left + 70
        this.createBox.upward = false
        this.createBox.aleft = false
      }
      const ScreenDistance = {
        left: ClickEvent.clientX,
        right: document.body.scrollWidth - ClickEvent.clientX
      }
      let Translation = 0
      if (this.createBox.aleft && ScreenDistance.right < 855) {
        Translation = ScreenDistance.right - 855
      } else if (!this.createBox.aleft && ScreenDistance.left < 855) {
        Translation = 855 - ScreenDistance.left
      }
      this.createBox.ArrowsLeft = FramePosition.ArrowsLeft + Math.abs(Translation)
      this.createBox.ArrowsLeft = this.createBox.ArrowsLeft > 360 ? 360 : this.createBox.ArrowsLeft
      this.createBox.top = this.createBox.top
      this.createBox.left = this.createBox.left + Translation
    },
    // 转换时间
    transformTime (time, idx, min) {
      if (idx == 0) {
        const TimeFormat = Outil.getDateTimeFormat()
        let Format = 'mFormat'
        if (TimeFormat.broadcastTimeFormat) {
          Format = ''
        }
        return this.getDateTime(time, min, undefined, Format)
      }
    },
    // 获取title
    getTitle (event) {
      return event.title
    },
    // 转换时间
    getDateTime (time, trIndex, second, timeFormat) {
      // let min = Number(time.split(':')[1]) + Number(Math.floor(trIndex / 60));
      let hour = time.split(':')[0]
      let min = Number(time.split(':')[1]) + Number(trIndex)
      if (min == 60) {
        hour = Number(hour) + 1
        min = '0'
      }
      second = second < 10 ? `0${second}` : second
      if (timeFormat == 'mFormat') {
        if (hour > 12) {
          time = `${hour - 12}:${min > 9 ? '' : '0'}${min}${
            second ? `:${second}` : ''
          } PM`
        } else {
          const hourVal = hour == 0 ? 12 : hour
          time = `${hourVal}:${min > 9 ? '' : '0'}${min}${
            second ? `:${second}` : ''
          } ${hour == 12 ? 'PM' : 'AM'}`
        }
      } else {
        time = `${hour}:${min > 9 ? '' : '0'}${min}:${second || '00'}`
      }

      return time
    }
  },
  beforeDestroy () {
    this.rendEvents && this.rendEvents.removeAll()
    this.boxElement && this.boxElement.close()
  },
  destroyed () {
    Bus.$off('leftListUpdate', this.registerDrag)
    Bus.$off('popupCreateBox')
  }
}
</script>
<style lang="less" scoped>
.green {
  background: #0fbe71;
  cursor: pointer;
}
.skyblue {
  background-color: #46c9e1;
  cursor: pointer;
  border-bottom: none !important;
}
.blue {
  background-color: #2f8df4;
  cursor: pointer;
  border-bottom: none !important;
}
.orange {
  background-color: #ffc573;
  cursor: pointer;
  border-bottom: none !important;
}
.pink {
  background-color: #ff6a92;
  cursor: pointer;
  border-bottom: none !important;
}
.yellow {
  background-color: #ffc000;
  cursor: pointer;
  border-bottom: none !important;
}
.purple {
  background-color: #9248c7;
  // border: 1px solid #9248C7;
  border-bottom: none !important;
}
.magnify {
  width: calc(100% - 600px);
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 100;
  .el-icon-close {
    position: absolute;
    right: 7px;
    top: -30px;
    font-size: 14px;
    border: 1px solid #444;
    padding: 3px;
    background: #333;
  }
}
.mask {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: #666;
  opacity: 0.5;
  z-index: 100;
}
.content {
  width: 80%;
  height: 650px;
  position: absolute;
  left: 50%;
  top: 53%;
  transform: translate(-50%, -50%);
  box-shadow: 0 0 15px #100400;
  background: #333;
  opacity: 1;
  z-index: 106;
  .calendar_content {
    height: calc(100% - 22px);
    overflow-y: scroll;
    width: calc(100% - 1px);
  }
  .tbody {
    height: 754px;
    overflow: hidden;
    box-sizing: border-box;
    border: 1px solid #555;
  }
  .title.tr {
    // padding-right: 5px;
    //  padding-left: 5.5%;
    border: 1px solid #555;
    border-bottom: none !important;
    font-weight: 700;
    font-size: 13px;
    //   width:calc(100% - 13.5%);
  }
  .formatTitle {
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      cursor: pointer;
    }
  }
  .tr {
    width: 100%;
    height: 25.2px;
    box-sizing: border-box;
    margin-right: 5px;
    font-size: 12px;
    .td,
    .th {
      width: 13.5%;
      height: 100%;
      float: left;
      box-sizing: border-box;
      border-right: 1px solid #555;
      line-height: 25px;
    }
    .td {
      color: #333;
      // overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .event_title {
      // position: absolute;
      // left: 50%;
      // top: 50%;
      // transform: translate(-50%, -50%);
    }
    // .event_box {
    //     width: 100%;
    //     z-index: 2;
    //     position: absolute;
    //     left: 0;
    //     top: 0;
    //     display: none;
    //     overflow: hidden;
    // }
    .second {
      width: 100%;
      height: 0.43px;
    }
  }
  .td:first-child,
  .th:first-child {
    width: 5.5%;
    color: #fff;
  }
  .th:nth-child(2) {
    margin-left: 5.5%;
  }
  .td:last-child,
  .th:last-child {
    border: none;
  }

  .tr:nth-child(2n) .td {
    border-bottom: 1px solid #555;
  }
  .tr:nth-child(2n + 1) .td {
    border-bottom: 1px dotted #555;
  }
  ::v-deep .fc-toolbar.fc-header-toolbar {
    display: none;
  }
  ::v-deep .fc-axis.fc-time.fc-widget-content {
    width: 56px !important;
    box-sizing: border-box;
  }
  ::v-deep .fc-row .fc-axis.fc-widget-header {
    width: 56px !important;
  }
  ::v-deep .fc-view.fc-agendaWeek-view.fc-agenda-view {
    background: #333;
  }
  ::v-deep td,
  ::v-deep th {
    border-color: #555 !important;
  }
}
@media (max-width: 1480px) {
  .magnify {
    width: calc(100% - 359px);
    left: 359px;
  }
  .content {
    width: 85%;
    .td {
      font-size: 11px;
    }
  }
}
@media (max-width: 1320px) {
  .magnify {
    width: calc(100% - 323px);
    left: 323px;
  }
  .content {
    width: 90%;
    .td {
      font-size: 11px;
    }
  }
}
</style>
